import { User } from '@/services/user/User'
import { COOKIE_CONSENT, STORE_CART_ITEMS, STORE_USER, VISITS_COUNTER } from '@/AppKeys'
import { UserTransformer } from '@/services/user/UserTransformer'
import { Artwork } from '@/services/artwork/Artwork'
import { ArtworkTransformer } from '@/services/artwork/ArtworkTransformer'

export default class LocalStorage {
  private static storage = localStorage

  /**
   *
   * @param key {String}
   */
  public static get (key: string) {
    const val = this.storage.getItem(key)
    if (!val) {
      return null
    }
    try {
      return JSON.parse(val)
    } catch (error) {
      return null
    }
  }

  /**
   *
   * @param key {String}
   * @param value
   */
  public static set (key: string, value: any) {
    this.storage.setItem(key, JSON.stringify(value))
  }

  /**
   *
   * @param key {String}
   */
  public static remove (key: string) {
    this.storage.removeItem(key)
  }

  public static get user (): User | null {
    if (this.get(STORE_USER)) {
      return new UserTransformer().toClass(this.get(STORE_USER))
    }
    return null
  }

  public static get cartItems (): Artwork[] {
    if (this.get(STORE_CART_ITEMS)) {
      const items = this.get(STORE_CART_ITEMS)
      if (items instanceof Array) {
        return items.map(item => new ArtworkTransformer().toClass(item))
      }
      // return new UserTransformer().toObject(this.get(STORE_USER));
      return []
    }
    return []
  }

  public static get visitsCounter (): number {
    if (this.get(VISITS_COUNTER)) {
      return Number(this.get(VISITS_COUNTER))
    }
    return 0
  }

  public static incrementVisitsCounter (val: number = 1) {
    this.set(VISITS_COUNTER, (this.visitsCounter + val))
  }

  public static get cookieConsent (): any {
    if (this.get(COOKIE_CONSENT)) {
      return this.get(COOKIE_CONSENT)
    }
    return null
  }

  public static setCookieConsent () {
    this.set(COOKIE_CONSENT, new Date().toISOString())
  }

  public static arrayFind<T> (key: string, criteria: (item: T, index: number) => boolean): null | T {
    const r = LocalStorage.get(key)
    if (!Array.isArray(r)) return null
    return r.find(criteria)
  }

  public static arrayAdd<T> (key: string, item: T): void {
    const r = LocalStorage.get(key)
    if (!Array.isArray(r)) {
      LocalStorage.set(key, [item])
      return
    }
    r.push(item)
    LocalStorage.set(key, r)
  }

}
